angular.module('unergie.main')
.controller('taxDeclarationCtrl', ($scope, $location, $state, $timeout, $filter, ApiUser, DataAccess, DataAccessSearch, Rules, BoFeaturesService, AlertManager, DownloadService,
    TableGeneratorService, FilterMapping, ErrorCatcher) => {
    $scope.tax_declaration_status_mapping = FilterMapping.taxDeclarationStatuses
    $scope.tax_declaration_type_mapping = FilterMapping.taxDeclarationTypes
    $scope.canSendTcfeMail = BoFeaturesService.isFeatureOn('canSendTcfeMail')
    $scope.canSendTcfePaymentData = BoFeaturesService.isFeatureOn('canSendTcfePaymentData')

    $scope.taxDeclarationPayload = {}
    $scope.taxDeclarationTemplate = {
        id: { label: 'ID', mode: 'search_operator' },
        execution_date: { label: 'Date d\'éxécution', mode: 'search_date' },
        declaration_year: { label: 'Année de declaration', mode: 'search_operator' },
        quarter_number: { label: 'Trimestre', mode: 'search_operator' },
        status: { label: 'Statut', mode: 'search_wildcard' },
    }

    $scope.declarationStatusMapping = {
        INITIAL: 'Initial',
        PROCESSING_SIMU: 'En cours de simulation',
        SUCCESS_SIMU: 'Simulation OK',
        ERROR_SIMU: 'Erreur de simulation',
        ERROR: 'Erreur',
        PROCESSING_RUN: 'En cours de traitement',
        PROCESSING_DONE: 'Cloturée',
        GENERATING_SYNC_DATA: 'En cours de génération',
        ERROR_SYNC_DATA: 'Erreur de synchronisation',
        CANCELLED: 'Annulée',
    }

    $scope.taxDeclaration = {
        refreshing: false,
        show: {},
        columns: {
            id: { label: 'ID', mode: 'search_operator' },
            execution_date: { label: 'Date d\'éxécution', mode: 'search_date' },
            declaration_year: { label: 'Année de declaration', mode: 'search_operator' },
            quarter_number: { label: 'Trimestre', mode: 'search_operator' },
            status: { label: 'Statut', mode: 'search_wildcard' },
        },
    }

    $scope.simulationField = {
        declaration_year: { label: 'Année à declarer', type: 'text', required: true, pattern: /^\d{4}$/ },
        quarter_number: { label: 'Trimestre à declarer', type: 'text', required: true, pattern: /^[1-4]{1}$/ },
    }

    $scope.simulationPayload = {
        declaration_year: null,
        quarter_number: null,
    }
    $scope.prepareNewSimulation = () => {
        $scope.simulationPayload = {
            declaration_year: undefined,
            quarter_number: undefined,
        }
    }
    const departmentColumns = {
        id: { label: 'Id', mode: 'search_operator' },
        siren: { label: 'SIREN', mode: 'search_operator' },
        department: { label: 'Departement', mode: 'search_operator' },
        label: { label: 'Libellé beneficiaire', mode: 'search_wildcard' },
        consumption: { label: 'Consommation en kWh', mode: 'search_operator' },
        amount: { label: 'Montant de la TDCFE', mode: 'search_operator' },
        declaration_fees: { label: 'Frais de declration', mode: 'search_operator' },
        kwh_tarif: { label: 'Taris/kWh', mode: 'search_operator' },
        vat_rate: { label: 'Taux de TVA', mode: 'search_operator' },
        odoo_instance: { label: 'Instance Odoo', mode: 'search_wildcard' },
    }

    const cityBeneficiaryColumns = {
        siren: { label: 'SIREN', mode: 'search_operator' },
        label: { label: 'Libellé beneficiaire', mode: 'search_wildcard' },
        consumption: { label: 'Consommation en kWh', mode: 'search_operator' },
        amount: { label: 'Montant de la TCCFE', mode: 'search_operator' },
        declaration_fees: { label: 'Frais de declration', mode: 'search_operator' },
        kwh_tarif: { label: 'Taris/kWh', mode: 'search_operator' },
        vat_rate: { label: 'Taux de TVA', mode: 'search_operator' },
        odoo_instance: { label: 'Instance Odoo', mode: 'search_wildcard' },
    }

    const syncViewColumns = {
        id: { label: 'Id', mode: 'search_operator' },
        siren: { label: 'SIREN', mode: 'search_operator' },
        label: { label: 'Libellé beneficiaire', mode: 'search_wildcard' },
        type_tax: { label: 'Type', mode: 'search_wildcard' },
        odoo_data: { label: 'Montant Odoo', mode: 'text' },
        benef_data: { label: 'Montant mail', mode: 'text' },
        pdf_path: { label: 'PDF', mode: 'search_wildcard' },
        xls_path: { label: 'XLS', mode: 'search_wildcard' },
        id_odoo: { label: 'Id Odoo', mode: 'search_wildcard' },
        sent_beneficiary: { label: 'Envoyé au beneficiare', mode: 'search_strict', title: "Oui: 'true', Non: 'false'" },
        odoo_instance: { label: 'Instance Odoo', mode: 'search_wildcard' },
    }

    $scope.updateTaxStatus = (c, newStatus) => {
        c.updating = true
        const query = {
            id_declaration: c.id,
            status: newStatus,
        }
        return DataAccess.updateTaxStatus(query, {}).$promise.then((result) => {
            AlertManager.success('MAJ statut OK')
            c.status = newStatus
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.updating = false
            $scope.refreshTaxDeclaration()
        })
    }

    $scope.launchTaxDeclaration = (launchMode = 'simulate') => {
        $scope.taxDeclarationInProgress = true
        const query = {
            mode: launchMode,
            year: $scope.simulationPayload.declaration_year,
            quarter: $scope.simulationPayload.quarter_number,
        }
        return DataAccess.launchTaxDeclaration(query, {}).$promise.then((result) => {
            AlertManager.success('Initialisation declaration OK')
        })
        .catch((error) => {
            AlertManager.error('Erreur lors de la simulation')
            console.log('Erreur lors de la simulation', error)
        })
        .finally(() => {
            $scope.refreshTaxDeclaration()
            $scope.taxDeclarationInProgress = false
        })
    }

    $scope.simulate = (c) => {
        c.simulating = true
        const query = {
            mode: 'simulate',
            year: c.declaration_year,
            quarter: c.quarter_number,
        }
        return DataAccess.launchTaxDeclaration(query, {}).$promise.then((result) => {
            AlertManager.success('Simulation OK')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshTaxDeclaration()
            c.simulating = false
        })
    }

    $scope.generateSyncData = (c) => {
        c.generatingSync = true
        return DataAccess.generateSyncData({ id_declaration: c.id }, {}).$promise.then(() => {
            AlertManager.success('Génération de données de synchronisation en cours')
        })
        .catch(ErrorCatcher)
        .finally(() => {
            c.generatingSync = false
        })
    }

    $scope.canGenerateSyncData = (c) => {
        return c.status === 'SUCCESS_SIMU'
    }

    $scope.selectAll = (c) =>
        _.forEach(c.sync.instance.data, (item) => {
            item.selected = true
        })


    $scope.deSelectAll = (c) =>
        _.forEach(c.sync.instance.data, (item) => {
            item.selected = false
            return true
        })

    $scope.getSelectedNumber = (c) => _.countBy(c.sync ? c.sync.instance.data : [], 'selected').true || 0

    $scope.simulable = (c) => {
        return c.status === 'SUCCESS_SIMU'
    }

    $scope.cancelable = (c) => {
        return c.status === 'SUCCESS_SIMU' || c.status === 'PROCESSING_RUN'
    }
    $scope.canClose = (c) => {
        return c.status === 'PROCESSING_RUN'
    }

    $scope.toggleExpand = (c) => {
        c.expanded = !c.expanded
        $scope.fetchDepartmentForTaxDeclaration(c)
    }

    const doneFetchingDepartments = (c) => () => {
        c.departments.fetched = true
    }

    $scope.getDepartmentFortaxDeclaration = (c) => {
        c.departments = {
            columns: _.clone(departmentColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(c.departments, 'department-tax-result-views', '', doneFetchingDepartments(c), { search: { id_declaration: c.id }, orderBy: '-consumption' })
    }

    $scope.fetchDepartmentForTaxDeclaration = (c) => {
        if (!c.departments || (!c.departments.fetched && !c.departments.refreshing)) {
            $scope.getDepartmentFortaxDeclaration(c)
        }
    }

    const doneFetchingCities = (c) => () => {
        c.cities.fetched = true
    }

    $scope.getCityFortaxDeclaration = (c) => {
        c.cities = {
            columns: _.clone(cityBeneficiaryColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(c.cities, 'city-tax-result-views', undefined, doneFetchingCities(c), { search: { id_declaration: c.id }, orderBy: '-consumption' })
    }

    $scope.fetchCityForTaxDeclaration = (c) => {
        if (!c.cities || (!c.cities.fetched && !c.cities.refreshing)) {
            $scope.getCityFortaxDeclaration(c)
        }
    }

    const doneFetchingSyncView = (c) => () => {
        c.sync.fetched = true
    }

    $scope.getSyncView = (c) => {
        c.sync = {
            columns: _.clone(syncViewColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(c.sync, 'tax-synchronization', undefined, doneFetchingSyncView(c), { search: { id_declaration: c.id } })
    }

    $scope.fetchSyncView = (c) => {
        if (!c.sync || (!c.sync.fetched && !c.sync.refreshing)) {
            $scope.getSyncView(c)
        }
    }

    $scope.payloadSyncOdoo = {
        limit: 100,
        typeTax: 'TCCFE',
    }
    $scope.syncOdooFields = {
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
        typeTax: {
            label: 'Type taxe',
            required: true,
            type: 'select',
            enum: [{ value: 'TCCFE', label: 'TCCFE' }, { value: 'TDCFE', label: 'TDCFE' }] },
    }

    $scope.toggleSelected = function (beneficiary, e) {
        e.preventDefault()
        e.stopPropagation()
        beneficiary.selected = !beneficiary.selected
    }

    $scope.getSelectedForGenerating = (c) =>
        _.filter(c, (beneficiary) => beneficiary.selected && (!beneficiary.pdf_path || beneficiary.pdf_path === ''))

    $scope.getSelectedForMail = (c) =>
        _.filter(c, (beneficiary) => beneficiary.selected && !beneficiary.sent_beneficiary)

    $scope.massGenerate = (c, list) => {
        c.massGenerating = true
        const payload = {
            tax_declaration: {
                id: c.id,
                declaration_year: c.declaration_year,
                quarter_number: c.quarter_number,
                execution_date: c.execution_date,
                status: c.status },
            beneficiaryList: $scope.getSelectedForGenerating(list) }
        ApiUser.generateTaxDocuments(payload).$promise.then((result) => {
            AlertManager.success('Document généré')
            $scope.refreshTaxDeclaration()
            if (c.status === 'PROCCESSING_ERROR') {
                $scope.updateTaxStatus(c, 'PROCESSING_RUN')
            }
        })
        .catch((error) => {
            AlertManager.error('Erreur lors de la génération')
            $scope.updateTaxStatus(c, 'PROCCESSING_ERROR')
        })
        .finally(() => {
            c.massGenerating = false
        })
    }

    $scope.massSendMail = (c, list) => {
        c.massSendingMail = true
        const payload = {
            tax_declaration: {
                id: c.id,
                declaration_year: c.declaration_year,
                quarter_number: c.quarter_number,
                execution_date: c.execution_date,
                status: c.status },
            beneficiaryList: $scope.getSelectedForMail(list) }
        ApiUser.sendTaxDeclarationMail(payload).$promise.then((result) => {
            AlertManager.success('Email envoyé au beneficiaire')
            $scope.refreshTaxDeclaration()
            if (c.status === 'PROCCESSING_ERROR') {
                $scope.updateTaxStatus(c, 'PROCESSING_RUN')
            }
        })
        .catch((error) => {
            AlertManager.error('Erreur lors de l envoie du mail au beneficiare')
        })
        .finally(() => {
            c.massSendingMail = false
        })
    }


    $scope.processOdoo = (c) => {
        $scope.processingOdoo = true
        const params = {
            limit: $scope.payloadSyncOdoo.limit,
            typeTax: $scope.payloadSyncOdoo.typeTax }
        return Rules.processOdooForTax(params).$promise.then((result) => {
            if (result && result.errors && result.errors.length) {
                AlertManager.error(`Problème de synchro avec odoo pour la declaration en cours : ${_.get(result, 'errors.0.detail.error_msg')}`, 10000)
            } else {
                AlertManager.success(`Batch de synchronisation lancé pour la declration en cours`)
            }
        })
        .catch((error) => {
            AlertManager.error('Erreur lors de la synchronisation avec odoo')
        })
        .finally(() => {
            AlertManager.success(`Synchronisation terminée`)
            $scope.processingOdoo = false
            $scope.refreshTaxDeclaration()
        })
    }

    $scope.totalOdoo = (c) =>
        _.round(_.sumBy(c, (o) => {
            return _.round(o.amount, 2) - _.round(o.declaration_fees, 2)
        }), 2)

    const CSV_DATA_COLS = [
        'label=Nom',
        'siren=Siren',
        'consumption=Consommation',
        'amount=Montant',
        'declaration_fees=Frais',
        'total=Totale',
        'iban=IBAN',
        'bic=BIC',
        'accountant_mail=Comptable',
        'beneficiary_mail=Bénéficiaire',
        'phone=Téléphone',
    ]

    $scope.payloadComptaDataField = {
        declaration_year: {
            label: 'Année',
            required: true,
            type: 'number',
        },
        quarter_number: {
            label: 'Trimestre',
            required: true,
            type: 'number',
        },
        typeTax: {
            label: 'Type taxe',
            required: true,
            type: 'select',
            enum: [{ value: 'TCCFE', label: 'TCCFE' }, { value: 'TDCFE', label: 'TDCFE' }] },
    }

    $scope.payloadComptaData = {
        declaration_year: { label: 'Année', type: 'number', required: true, pattern: /^\d{4}$/ },
        quarter_number: { label: 'Trimestre', type: 'number', required: true, pattern: /^[1-4]{1}$/ },
        typeTax: 'TCCFE',
    }

    $scope.generateTaxCsv = () => {
        const handler = {
            preventAddressBar: true,
        }
        const search = {
            quarter_number: $scope.payloadComptaData.quarter_number,
            declaration_year: $scope.payloadComptaData.declaration_year,
            type_tax: $scope.payloadComptaData.typeTax,
        }
        TableGeneratorService.getTable(handler, 'vw-tax-beneficiary-data', null, null, { search, columns: CSV_DATA_COLS })
        handler.instance.csv(`${$scope.payloadComptaData.typeTax}_${$scope.payloadComptaData.declaration_year}_${$scope.payloadComptaData.quarter_number}.csv`)
    }


    $scope.download = (file) => DownloadService.downloadFile(`/api-admin/s3-download?file=${file}`)

    const fieldsToCheck = [
        'id',
        'execution_date',
        'declaration_year',
        'quarter_number',
        'status',
    ]

    // check that fields are all set
    $scope.checkComplete = (c) => {
        return !_.some(_.pick(c, fieldsToCheck), (e) => !e)
    }
    const activate = () => {
        TableGeneratorService.getTable($scope.taxDeclaration, 'tax-declaration', '', null, { orderBy: 'execution_date' })
    }

    $scope.refreshTaxDeclaration = activate

    activate()
})
